import APIClient from '@/shared/http/clients/api'

const resourceName = 'relatorio/movimentacao-card'
const APICore = process.env.APIBaseURLCore

export default {
  GetAll (filters, page, size, sort) {
    let query = `?page=${page || 0}&size=${size || 10}`
    if (sort) {
      query += `&sort=${sort}`
    }
    return APIClient.post(`${APICore}/${resourceName}/${query}`, filters)
  },
  Export (filters, columnsFilter) {
    return APIClient.post(`${APICore}/${resourceName}/export`, {
      filter: filters,
      columnsFilter: columnsFilter
    })
  }
}



// WEBPACK FOOTER //
// ./src/shared/http/repositories/reports/movimentacao/ReportMovimentacaoRepository.js